export default __webpack_public_path__ + "static/media/Greenhouse_06.ff3de78c.webp";